export class CreditAgentFormData {
    public agentCode: string;
    public agencyCode: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/credit-agent-form-data.model.ts